import { render, staticRenderFns } from "./FormPicker.vue?vue&type=template&id=24a8f750&scoped=true&"
import script from "./FormPicker.vue?vue&type=script&lang=js&"
export * from "./FormPicker.vue?vue&type=script&lang=js&"
import style0 from "./FormPicker.vue?vue&type=style&index=0&id=24a8f750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8f750",
  null
  
)

export default component.exports